module.exports = __webpack_public_path__ + "static/media/icon_download.947a6b75.svg";